import DashboardContainer from './DashboardContainer';
import './index.scss';

export default DashboardContainer;
